import React, { useState, useEffect } from 'react';
import {
	getSentInvitations,
	getVisitsByOrgId,
} from '../../../../api/VisitsAPI';
import PurpleLoadingSpinner from '../../../../../assets/images/loading-spinner-purple.svg';
import { ShareProfile } from '../../shared/ShareProfiles';

export const OrganizationVisitsTab = ({ currentUser, orgID }) => {
	const [views, setViews] = useState([]);
	const [isFetching, setIsFetching] = useState(false);

	useEffect(() => {
		const fetchViews = async () => {
			setIsFetching(true);
			const { data } = await getVisitsByOrgId(orgID);
			setViews(data);
			setIsFetching(false);
		};
		fetchViews();
	}, []);

	if (isFetching) {
		return (
			<div className="loading-button-visits-tab">
				<img
					src={PurpleLoadingSpinner}
					alt="Sponsor Circle Loading Circle"
				/>
			</div>
		);
	}

	const ProfileShareFeatureComponent = () => {
		if (!currentUser?.admin) {
			return null;
		}

		return (
			<div style={{ marginBottom: '20px' }}>
				<ShareProfile orgID={orgID} />
			</div>
		);
	};

	const VisitTablesComponent = () => {
		if (!views || views.length === 0) {
			return <p>No Data Avilable</p>;
		}

		return (
			<table className="table-body">
				<thead>
					<tr>
						<th style={{ minWidth: '100px' }} colSpan={1}>
							Visiting user
						</th>
						<th style={{ minWidth: '100px' }} colSpan={1}>
							Invite date
						</th>
						<th style={{ minWidth: '100px' }} colSpan={1}>
							Visit date
						</th>
						<th style={{ minWidth: '130px' }} colSpan={1}>
							Total visit time
						</th>
						<th style={{ minWidth: '120px' }} colSpan={1}>
							Overview tab
						</th>
						<th style={{ minWidth: '130px' }} colSpan={1}>
							Campaigns tab
						</th>
					</tr>
					<tr>
						<th scope="col"></th>
						<th scope="col"></th>
						<th scope="col"></th>
						<th scope="col">
							<i className="far fa-clock"></i>
						</th>
						<th scope="col">#</th>
						<th scope="col">#</th>
					</tr>
				</thead>
				<tbody className="visitor-activity-table-body">
					{views &&
						views.map((view) => {
							let visitingUser = view?.visitor_identifier;
							let link = '';
							if (view.user_organization) {
								link = `/organizations/${view.user_organization.id}`;
								visitingUser = (
									<a href={link}>
										{view?.visitor_identifier}
									</a>
								);
							}

							return (
								<tr key={view.id}>
									<td
										data-label={
											view.user_organization
												? 'User'
												: link
										}
									>
										{visitingUser}
									</td>
									<td data-label="Invite date">
										{view?.invite_date}
									</td>
									<td data-label="Visit date">
										{view?.visit_date}
									</td>
									<td data-label="Visit time">
										{view?.visit_duration}
									</td>
									<td data-label="Overview tab count">
										{view?.overview_tab_click_count}
									</td>
									<td data-label="Opportunities tab count">
										{view?.opportunitiy_tab_click_count}
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		);
	};

	return (
		<>
			<ProfileShareFeatureComponent />
			<VisitTablesComponent />
			<InvitationsTable orgID={orgID} />
		</>
	);
};

const InvitationsTable = ({ orgID }) => {
	const [invitations, setInvitations] = useState([]);

	const fetchInvitations = async (orgID) => {
		const { data } = await getSentInvitations(orgID);
		setInvitations(data);
	};

	useEffect(() => {
		fetchInvitations(orgID);
	}, []);

	return (
		<table>
			<thead>
				<tr>
					<th colSpan={2}>Invitations sent</th>
					<th colSpan={2}></th>
				</tr>
			</thead>
			<tbody className="visitor-activity-table-body">
				{invitations.map((invitation) => {
					return (
						<tr key={invitation.id}>
							<td data-label="Email" colSpan={2}>
								{invitation.email}
							</td>
							<td data-label="Date" colSpan={2}>
								{invitation?.invite_date}
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};
